import {
    FETCH_PRODUCT_OCCUPANCY,
    FETCH_PRODUCT_OCCUPANCY_FAILURE,
    FETCH_PRODUCT_OCCUPANCY_SUCCESS,
} from 'store/actions/types';

export const fetchProductOccupancy = (payload, id) => {
    const params = {
        params: payload,
        id: id,
    };

    return {
        type: FETCH_PRODUCT_OCCUPANCY,
        payload: params,
    };
};

export const fetchProductOccupancyFailure = (error) => {
    return {
        type: FETCH_PRODUCT_OCCUPANCY_FAILURE,
        error: error,
    };
};

export const fetchProductOccupancySuccess = (response, payload) => {
    return {
        type: FETCH_PRODUCT_OCCUPANCY_SUCCESS,
        response: response,
        payload: payload,
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/products/occupancy/fetchProductOccupancy.js